import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { PLATES } from "../../data/site";

/* A full-bleed breath between Services and Process. This used to be three
   plates in a card grid, which boxed the photography off as a gallery — the
   opposite of what it should do sitting under the section that sells it.
   Edge-to-edge with the type running over it reads as the studio's own work
   carrying the page instead.

   The image is deliberately oversized and translated rather than scaled on a
   container: moving a taller-than-viewport image inside a clipped band is a
   compositor-only transform, so the parallax costs nothing per frame. */
export const FieldWork = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-9%", "9%"]);

  return (
    <section
      ref={ref}
      data-testid="field-work"
      className="relative h-[62vh] md:h-[80vh] overflow-hidden bg-charcoal"
    >
      <motion.img
        style={{ y }}
        src={PLATES.break}
        alt=""
        aria-hidden="true"
        loading="lazy"
        decoding="async"
        className="duotone-plate absolute inset-0 h-[124%] w-full object-cover"
      />
      {/* Order matters: .duotone-wash targets the element right after
          .duotone-plate, so this has to come before the charcoal veil below. */}
      <div aria-hidden="true" className="duotone-wash" />

      {/* The plate sits dark even after toning. A light wash keeps the grid
          rules and registration marks legible over it without flattening
          the photograph further. */}
      <div aria-hidden="true" className="absolute inset-0 bg-charcoal/20" />
    </section>
  );
};
